// 서버의 "YYYY-MM-DD HH:mm:ss" 문자열을 사용자 언어에 맞는 날짜로 바꾼다 (예: 2025년 10월 22일)
export function localizedDateSimpleString(from: string): string {
  const [datePart, timePart = "00:00:00"] = from.trim().split(" ");
  const [year, month, day] = (datePart ?? "").split("-").map(Number);
  const [hour, minute, second] = timePart.split(":").map(Number);

  if (!year || !month || !day) {
    return "";
  }

  const date = new Date(
    year,
    month - 1,
    day,
    hour || 0,
    minute || 0,
    second || 0
  );

  const formatter = new Intl.DateTimeFormat(undefined, {
    dateStyle: "long",
  });
  return formatter.format(date);
}
